import { useState, useCallback, useEffect } from 'react';
import Observer from '@researchgate/react-intersection-observer';
import useReduxStateMarkets from '@/pages/Market/hooks/useReduxStateMarkets';
import { useTracking } from 'react-tracking';
import { IntersectionBox } from './styled';
import useIndustryGetter from '@/pages/Market/hooks/useIndustryGetter';

interface Props {
  subject: string;
}

const ScrollTracking = ({ subject }: Props) => {
  const [isTracked, setIsTracked] = useState(false);
  const { trackEvent } = useTracking();
  const { market, sector, secondary, tertiary } = useReduxStateMarkets();
  const [{ id }] = useIndustryGetter();
  const handleObserverChanged = useCallback(
    ({ isIntersecting }) => {
      if (isIntersecting && !isTracked) {
        trackEvent({
          type: 'track',
          subject,
          action: 'scroll',
          market,
          industryId: id,
        });
        setIsTracked(true);
      }
    },
    [isTracked, market, id, subject]
  );
  useEffect(() => {
    if (isTracked) {
      setIsTracked(false);
    }
  }, [market, sector, secondary, tertiary]);
  return (
    <Observer onChange={handleObserverChanged}>
      <IntersectionBox />
    </Observer>
  );
};

export default ScrollTracking;
